/**
 * Formats file size in bytes to human-readable format
 * @param sizeInBytes - File size in bytes
 * @returns Formatted size string (KB for < 1MB, MB for >= 1MB)
 */
export const formatFileSize = (sizeInBytes: number): string => {
  const sizeInKB = sizeInBytes / 1024;
  const sizeInMB = sizeInKB / 1024;

  if (sizeInMB >= 1) {
    return `${sizeInMB.toFixed(2)}MB`;
  }

  return `${Math.round(sizeInKB)}KB`;
};
